import styled from 'styled-components';

import { pxToRem } from '../../../utils/styles';

export const PromoCodeContainer = styled.div`
  &&& {
    display: flex;
    flex-direction: column;
    margin: ${pxToRem(20)} 0;
    width: 100%;
    max-width: ${pxToRem(896)};
  }
`;

export const Divider = styled.div`
  &&& {
    width: 100%;
    height: 1px;
    background-color: ${({ theme }) => theme.colors.brand1};
  }
`;

export const ContentWrapper = styled.div`
  &&& {
    margin-top: ${pxToRem(30)};
    margin-bottom: ${pxToRem(30)};
  }
`;

export const Row = styled.div`
  &&& {
    display: flex;
    align-items: center;
    gap: ${pxToRem(5)};
    height: ${pxToRem(40)};
  }
`;

export const PromoCodeAction = styled.div<{ $setMarginBottom: boolean }>`
  &&& {
    color: red;
  }
`;

export const ValidationError = styled.div`
  &&& {
    margin-top: ${pxToRem(5)};
  }
`;
export const InputWrapper = styled.div`
  &&& {
    flex-basis: 100%;
  }
`;
